import SupportedCountries from "./Supported.countries";
import {UseFormReturnType} from "@mantine/form/lib/use-form";

interface SupportedCountries {
    [key: string]: SupportedCountry,
}

interface SupportedCountry {
    display: string,
    formItems: any[]
}


export const supportedCountries = (form: UseFormReturnType<any>, disableAllFields?:boolean): SupportedCountries => ({
    BD: SupportedCountries.Bangladesh(form, disableAllFields),
    CN: SupportedCountries.China(form, disableAllFields),
    ID: SupportedCountries.Indonesia(form, disableAllFields),
    JP: SupportedCountries.Japan(form, disableAllFields),
    KH: SupportedCountries.Cambodia(form, disableAllFields),
    MY: SupportedCountries.Malaysia(form, disableAllFields),
    PK: SupportedCountries.Pakistan(form, disableAllFields),
    US: SupportedCountries.UnitedStates(form, disableAllFields),
    VN: SupportedCountries.Vietnam(form, disableAllFields),
    TH: SupportedCountries.Thailand(form, disableAllFields),
})
 
